import {
  InsertData,
  InsertDataWithImage,
  
} from "../../Hooks/InsertData";
import { GetData } from "../../Hooks/getAllData";
import {
  CREATE_CATEGORIES,
  CREATE_CARS,
  GETALL_CARS,
  GETALL_CATEGORIES,
  UPDATE_CARS,
  DELETE_CARS,
  DELETE_CATEGORY,UPDATE_CATEGORY, GETCARBYID,
  
} from "../type";

//create new user
export const createCategoryAction = (data) => async (dispatch) => {
  try {
    const response = await InsertData(`/api/create-category/`, data);
    dispatch({
      type: CREATE_CATEGORIES,
      payload: response,
      
    });
  } catch (e) {
    dispatch({
      type: CREATE_CATEGORIES,
      payload: e.response,
    });
  }
};
export const UpdateCategoryAction = (data) => async (dispatch) => {
  try {
    const response = await InsertData(`/api/update-category/`, data);
    dispatch({
      type: UPDATE_CATEGORY,
      payload: response,
      
    });
  } catch (e) {
    dispatch({
      type: UPDATE_CATEGORY,
      payload: e.response,
    });
  }
};
export const deleteCategoryAction = (data) => async (dispatch) => {
  try {
    const response = await InsertData(`/api/delete-category/`, data);
    dispatch({
      type: DELETE_CATEGORY,
      payload: response,
      
    });
  } catch (e) {
    dispatch({
      type: DELETE_CATEGORY,
      payload: e.response,
    });
  }
};
export const createCarAction = (data) => async (dispatch) => {
  try {
    const response = await InsertDataWithImage(`/api/create-car/`, data);
    dispatch({
      type: CREATE_CARS,
      payload: response,
      
      
    });
  } catch (e) {
    dispatch({
      type: CREATE_CARS,
      payload: e.response,
    });   
  }
};
export const UpdatecarAction = (data) => async (dispatch) => {
  try {
    const response = await InsertDataWithImage(`/api/update-car-data/`, data);
    dispatch({
      type: UPDATE_CARS,
      payload: response,
      
    });
  } catch (e) {
    dispatch({
      type: UPDATE_CARS,
      payload: e.response,
    });
  }
};

//login  user
export const getAllCarAction = (query) => async (dispatch) => {
  try {
    const response = await GetData(`/api/all-cars/?${query}`);
    dispatch({
      type: GETALL_CARS,
      payload: response,
      
    });
  } catch (e) {
    dispatch({
      type: GETALL_CARS,
      payload: e.response,
    });
  }
};
export const getCarByIdAction = (id) => async (dispatch) => {
  try {
    const response = await GetData(`/api/get-cat/${id}/`);
    dispatch({
      type: GETCARBYID,
      payload: response,
      
    });
  } catch (e) {
    dispatch({
      type: GETCARBYID,
      payload: e.response,
    });
  }
};
export const getAllCategoryAction = () => async (dispatch) => {
  try {
    const response = await GetData(`/api/get-categories/`);
    dispatch({
      type: GETALL_CATEGORIES,
      payload: response,
      
    });
  } catch (e) {
    dispatch({
      type: GETALL_CATEGORIES,
      payload: e.response,
    });
  }
};
export const DeleteCarAction = (data) => async (dispatch) => {
  try {
    const response = await InsertData(`/api/delete-car/`,data);
    dispatch({
      type: DELETE_CARS,
      payload: response,
      
    });
  } catch (e) {
    dispatch({
      type: DELETE_CARS,
      payload: e.response,
    });
  }
};
